import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import { useTranslation } from "../../../i18n";
import { Link as RouterLink } from "react-router-dom";
import { useTeam } from "../TeamLayout";
import { Breadcrumbs, Card, CardContent, Chip, Link } from "@mui/joy";
import HomeIcon from "@mui/icons-material/Home";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import SettingsIconOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { useTeamDashQuery } from "../../../__generated__/types-and-hooks";
import OnlineUsersToggle from "../../../components/OnlineUsersToggle";

export default function TeamDash() {
  const t = useTranslation();
  const teamCtx = useTeam();
  const teamDashQuery = useTeamDashQuery({
    variables: { teamId: teamCtx.team.id },
  });
  const analytics = teamDashQuery.data?.analytics_team;

  return (
    <>
      <Breadcrumbs
        aria-label="breadcrumbs"
        sx={{
          "--Breadcrumbs-gap": "4px",
          m: 1,
        }}
        size="sm"
      >
        <Link component={RouterLink} color="neutral" to="/">
          <HomeIcon />
        </Link>
        <Typography level="title-sm">{teamCtx.team.name}</Typography>
        <OnlineUsersToggle />
      </Breadcrumbs>
      <Box
        sx={{
          p: 2,
          width: "100%",
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(min(100%, 250px), 1fr))",
        }}
        gap={2}
      >
        <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background: "hsl(0deg 0% 31.06% / 35%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background: "hsl(0deg 0% 51.06% / 35%)",
            },
          }}
        >
          <FactCheckOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg" id="card-description">
              {t("Inspections")}{" "}
              <Chip size="md" variant="outlined">
                {analytics?.inspections?.total}
              </Chip>
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./inspections"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                <Box>
                  {t("Track and oversee all your QC inspections efficiently.")}
                </Box>
              </Link>
            </Typography>
          </CardContent>
        </Card>

        <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background: "hsl(0deg 0% 31.06% / 35%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background: "hsl(0deg 0% 51.06% / 35%)",
            },
          }}
        >
          <CategoryOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg" id="card-description">
              {t("SKUs")}{" "}
              <Chip size="md" variant="outlined">
                {analytics?.skus?.count}
              </Chip>
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./sku"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                {t(
                  "Organize, monitor, and update all your product SKUs in real time."
                )}
              </Link>
            </Typography>
          </CardContent>
        </Card>

        {/* <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background:
              "radial-gradient(circle at 50% 50%, rgb(0 0 0) 20%, transparent 80%), conic-gradient(from 45deg at 50% 50%, rgb(5 2 33) 0%, rgb(11 17 43) 25%, rgb(2 6 33) 50%, rgb(13 41 51) 75%, rgb(7 2 33) 100%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background:
                "radial-gradient(circle at 50% 50%, rgb(0 0 0) 20%, transparent 80%), conic-gradient(from 45deg at 50% 50%, rgb(7 2 33) 0%, rgb(13 41 51), rgb(2 6 33) 50%, rgb(11 17 43) 25% 75%, rgb(5 2 33) 100%)",
            },
          }}
        >
          <ReceiptOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg" id="card-description">
              {t("Purchase Orders")}
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./purchase-orders"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                {t("Manage POs")}
              </Link>
            </Typography>
          </CardContent>
        </Card> */}

        <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background: "hsl(0deg 0% 31.06% / 35%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background: "hsl(0deg 0% 51.06% / 35%)",
            },
          }}
        >
          <FactoryOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg">
              {t("Suppliers")}{" "}
              <Chip size="md" variant="outlined">
                {analytics?.suppliers?.count}
              </Chip>
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./suppliers"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                {t(
                  "Keep supplier information organized and accessible, streamlining your QC workflow."
                )}
              </Link>
            </Typography>
          </CardContent>
        </Card>

        <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background: "hsl(0deg 0% 31.06% / 35%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background: "hsl(0deg 0% 51.06% / 35%)",
            },
          }}
        >
          <ContactPageOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg">
              {t("Contacts")}{" "}
              <Chip size="md" variant="outlined">
                {analytics?.contacts?.count}
              </Chip>
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./contacts"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                {t(
                  "Save, organize, and quickly access all supplier and brand contacts."
                )}
              </Link>
            </Typography>
          </CardContent>
        </Card>

        <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background: "hsl(0deg 0% 31.06% / 35%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background: "hsl(0deg 0% 51.06% / 35%)",
            },
          }}
        >
          <ForumOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg" id="card-description">
              {t("Chat")}
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./chat"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                {t(
                  "Discuss inspections and share updates instantly with your team."
                )}
              </Link>
            </Typography>
          </CardContent>
        </Card>

        <Card
          variant="outlined"
          orientation="horizontal"
          sx={{
            background: "hsl(0deg 0% 31.06% / 35%)",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
              background: "hsl(0deg 0% 51.06% / 35%)",
            },
          }}
        >
          <SettingsIconOutlinedIcon fontSize="large" />
          <CardContent>
            <Typography level="title-lg" id="card-description">
              {t("Settings")}
            </Typography>
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              <Link
                component={RouterLink}
                color="neutral"
                to="./settings"
                overlay
                underline="none"
                sx={{ color: "text.tertiary" }}
              >
                {t(
                  "Configure your team, integrations, and account preferences for smooth operations."
                )}
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
